import { SettingsContentWrapper } from '@legacy/components/layout/SettingsContentWrapper';
import { useTranslation } from 'react-i18next';
import { PageSettingsWrapper } from '../../components/PageSettingsWrapper';

export const NewNavigationEntry = () => {
  const { t } = useTranslation('pageSettings');
  return (
    <PageSettingsWrapper>
      <SettingsContentWrapper
        header={t('HeaderTitle')}
        description={t('NoSettingsDescription')}
      />
    </PageSettingsWrapper>
  );
};
